exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.switch-input-container[data-v-457d9934] {\n    height: 0px;\n}\n.vuetable-slot .switch-input-container[data-v-457d9934] {\n    margin-top: -15px;\n}\n", ""]);

// exports
